import React from 'react';
import { Video } from 'lucide-react';

const Header = () => {
    return (
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <div className="flex items-center gap-3 mb-2">
                <div className="bg-indigo-600 p-3 rounded-lg">
                    <Video className="text-white" size={32} />
                </div>
                <div>
                    <h1 className="text-3xl font-bold text-gray-800">Worm Detection System</h1>
                    <p className="text-gray-600">AI-Powered Parasitic Worm Counter for Medical Analysis</p>
                </div>
            </div>
        </div>
    );
};

export default Header;